import { render, staticRenderFns } from "./Floor.vue?vue&type=template&id=32b5d5e0&scoped=true&"
import script from "./Floor.vue?vue&type=script&lang=js&"
export * from "./Floor.vue?vue&type=script&lang=js&"
import style0 from "./Floor.vue?vue&type=style&index=0&id=32b5d5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5d5e0",
  null
  
)

export default component.exports